import { JourneyLevel, JourneyStep } from '@labrav/react-components'

export interface BuyerDataStates {
  states: Record<string, string>
}

export interface BuyerContractsJourney {
  journey: JourneyLevel[]
}

export const transformApiDataToJourneySteps = (
  contractStatesArray: BuyerDataStates[],
  iconMap: Record<string, { icon: JSX.Element | ''; label: string }>
): JourneyLevel[] => {
  const buyerContractsJourney: BuyerContractsJourney = { journey: [] }

  contractStatesArray.forEach((contractStates, levelIndex) => {
    const steps: JourneyStep[] = Object.keys(contractStates.states || {})
      .map(key => {
        if (iconMap[key]) {
          return {
            ...iconMap[key],
            date: contractStates.states[
              key as keyof typeof contractStates.states
            ],
          }
        }
        return null
      })
      .filter(Boolean) as JourneyStep[]

    if (steps.length > 0) {
      buyerContractsJourney.journey.push({
        levelNumber: levelIndex + 1,
        steps,
      })
    }
  })

  return buyerContractsJourney.journey
}
